module.exports = __webpack_public_path__ + "img/gintzin_bottle.f8eaad38.jpg";